import { Box, IconButton, Modal, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { CloseIcon } from "src/components/icons/ActionIcons";
import GridKeikka_NewKeikkaCore from "../GridKeikka_NewKeikkaCore";
import "./gridKeikka_NewKeikka_Styles.css";
import MyDivider from "src/components/layout/MyDivider";

const styles = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
};

export default function GridKeikka_NewKeikkaModal({ isOpen, onSelect, defaults }) {
  const handleCancelKlik = () => onSelect(null);

  return (
    <Modal
      sx={styles.modal}
      open={isOpen}
      slotProps={{
        backdrop: {
          timeout: 1000,
        },
      }}
      onClose={handleCancelKlik}>
      <Box className="newKeikka_Modal">
        <Paper elevation={2} className="stepContainer" style={{ paddingTop: 5 }}>
          <div className="spaceBetween harmaaTausta">
            <div />
            <div className="center" style={{ flexDirection: "column" }}>
              <Typography variant="h6" color="primary" noWrap sx={{ fontSize: "1.1em" }}>
                Tilauksen lähde
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                noWrap
                sx={{ opacity: 0.7, fontSize: "0.8em" }}>
                Mistä tilaus on saapunut?
              </Typography>
            </div>
            <IconButton sx={{ right: 0, top: 0 }} onClick={handleCancelKlik}>
              <CloseIcon color="primary" />
            </IconButton>
          </div>
          <MyDivider />
          <GridKeikka_NewKeikkaCore defaults={defaults} onSelect={onSelect} />
        </Paper>
      </Box>
    </Modal>
  );
}

GridKeikka_NewKeikkaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  defaults: PropTypes.object,
};
